export const url = {
  CDN_URL: 'https://web-shop-assets.s3.eu-central-1.amazonaws.com',
  offers: '/webshop/offers?offer_type=power',
  regions: '/webshop/regions',
  userDetails: '/dashboard',
  dashboard: `${import.meta.env.VITE_DASHBOARD_REDIRECT_URL}/dashboard`,
  checkout: '/webshop/checkout',
  redirectLogin: (returnUrl: string) => `${import.meta.env.VITE_REDIRECT_URL}${returnUrl}`,
  redirectDashboard: `${import.meta.env.VITE_FABLEBORNE_URL}/dashboard`,
  redirectToOrderHistory: `${import.meta.env.VITE_FABLEBORNE_URL}/order-history`,

  guildOverview: '/guild/overview',
  guildOffers: '/guild/offers',
  guildOfferCheckout: '/guild/checkout',
};
